/** A list's filters: plain values only, so TanStack Query can hash and partially match them. */
export type QueryFilterValue = string | number | boolean | null;
export type QueryFilters = Readonly<Record<string, QueryFilterValue | readonly QueryFilterValue[]>>;

/**
 * The query keys of one kind of server data, in one shape for every feature:
 *
 *   all        ["tasks"]                              everything of this kind
 *   lists()    ["tasks", "list"]                      every list, whatever its filters
 *   list(f)    ["tasks", "list", { project: "NOON" }] one filtered list
 *   details()  ["tasks", "detail"]                    every single item
 *   detail(id) ["tasks", "detail", "NOON-12"]         one item
 *
 * Invalidating a shorter key refreshes everything under it.
 */
export function makeKeys<const Scope extends string>(scope: Scope) {
  const all = [scope] as const;
  return {
    all,
    lists: () => [...all, "list"] as const,
    list: (filters: QueryFilters = {}) => [...all, "list", filters] as const,
    details: () => [...all, "detail"] as const,
    detail: (id: string) => [...all, "detail", id] as const,
  };
}
